import { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Prompt } from 'react-router-dom';
import { Alert, Breadcrumb, Button, Card, Space, Steps, Typography } from 'antd';
import CollectionCreatorSteps from './CollectionCreatorSteps';
import { fetchUserCreatedModules, fetchUserPolicyModel, setUserCreatedModules } from '../actions/contentCreation';

const { Step } = Steps;
const { Paragraph, Text, Title } = Typography;

class CollectionCreator extends Component {

    constructor(props){
        super(props);
        this.state = {
            currentStep: 0,
            collection: {
                name: "Sample Collection Name",
                description: "Sample Description",
                longDescription: "Sample Long Description",
                primaryAuthorUsername: "",
                coAuthorUsernames: [],
                valuePrice: 0,
                collectionNetPrice: 0
            },
            modules: [],
            authorsDict: {},
            videoBank: [],
            allVideos: []
        }
    }

    componentDidMount() {
        this.props.fetchUserPolicyModel(this.props.currentUser.id)
        this.props.fetchUserCreatedModules(this.props.currentUser.id)
    }

    updateState = (key, pair) => {
        this.setState({
            [key]: pair
        })
    }
    goToPreviousStep = () => {
        this.setState({
            currentStep: this.state.currentStep - 1
        })
    }

    goToNextStep = () => {
        this.setState({
            currentStep: this.state.currentStep + 1
        })
    }

    render() {
        return  <div className="centered-container">
                    <div className="collection-creator-container">
                        <Prompt
                            when={this.state.currentStep != 3 && this.state.currentStep != 0}
                            message='Any changes you have made will not be saved, are you sure you want to leave?'
                        />
                        <Space className="breadcrumbs">
                            <Breadcrumb>
                                <Breadcrumb.Item><Link to="/creator/home">Creator Home</Link></Breadcrumb.Item>
                                <Breadcrumb.Item>Create a Collection</Breadcrumb.Item>
                            </Breadcrumb>
                        </Space>
                        <Card>
                            <Title level={4}>Creating a Collection</Title>
                            <Steps size="small" current={this.state.currentStep}>
                                <Step title={this.state.currentStep === 0 ? "Collection Details" : "Finished"} />
                                <Step title={this.state.currentStep <= 1 ? "Add Modules" : "Finished"} />
                                <Step title={this.state.currentStep <= 2 ? "Review Changes" : "Finished"} />
                                <Step title={this.state.currentStep <= 3 ? "Done" : "Finished"} />
                            </Steps>

                            <Card bordered={false} className="collection-creator-steps-container">
                                <CollectionCreatorSteps 
                                    allVideos={this.state.allVideos}
                                    collection={this.state.collection}
                                    currentStep={this.state.currentStep}
                                    goToNextStep={this.goToNextStep}
                                    goToPreviousStep={this.goToPreviousStep}
                                    modules={this.state.modules}
                                    videoBank={this.state.videoBank}
                                    updateState={this.updateState}
                                    createdModules={this.props.createdModules}
                                    authorsDict={this.state.authorsDict}
                                    currentUser={this.props.currentUser}
                                    setUserCreatedModules={this.props.setUserCreatedModules}
                                />
                            </Card>
                        </Card>
                    </div>
                    <div className="collection-creator-container-mobile">
                        <Alert
                            message="Unavailable on current screen size"
                            description="The Collection Creator is not available on your current screen size. Please try using another device."
                            type="info"
                            showIcon
                            action={
                                <Button size="small" type="primary" >
                                    <Link to='/creator/home/'>
                                        Go back
                                    </Link>
                                </Button>
                              }
                        />
                    </div>
                </div>
    }
}

const mapStateToProps = state => {
    return {
        createdModules: state.contentCreationReducer.userCreatedModules,
        currentUser: state.userReducer.user,
        
    }
}

export default connect(mapStateToProps, { fetchUserCreatedModules, fetchUserPolicyModel, setUserCreatedModules })(CollectionCreator);